import type { TenantConfig } from '@/types/TenantConfig'

const blue = '#91A3AE'
const grey = '#E5E5E5'

export const qtix: TenantConfig = {
  logo: 'assets/qtix/static/logo.png',
  themeOptions: {
    primaryColor: 'black',
    secondaryColor: 'black',
    footerBackgroundColor: 'black',
    footerTextColor: 'white',
    logoHeight: '45px',
    headerHeight: '100px',
    pageBackgroundColor: 'white',
    headerTopBorder: `10px solid ${blue}`,
    headerBottomBorder: `1px solid ${grey}`,
    cartHeaderBackgroundColor: blue,
    datePicker: {
      dayTextColor: 'black',
      disabledDayTextColor: '#d0d3db',
    },
  },
  componentOptions: {
    stripeCreditCard: {
      fontFaceStylesheet: 'https://use.typekit.net/tsu4pxd.css',
    },
    completedOrdersRoute: {
      completedContentOffset: {
        desktop: '100px',
        mobile: '50px',
      },
    },
  },
}
